import { toStatusType } from 'App/rtk';
import { useGetPlanDebtDataQuery } from '../billingPlansApi';

export function useShouldScheduleDowngrade() {
  const { data, status, refetch } = useGetPlanDebtDataQuery();
  const hasPaidDaysRemaining =
    !!data?.paidUntilDate && new Date() <= new Date(data.paidUntilDate);
  const shouldScheduleDowngrade = hasPaidDaysRemaining;
  return {
    shouldScheduleDowngrade,
    downgradeDate: data?.nextPaymentDate,
    status: toStatusType(status),
    retryLoad: refetch,
  };
}
